$(".mentors.mentor_details").ready(function () {
  $("form").on("keydown", "#user_profile_intro", function (e) {
    if (e.keyCode == 13) {
      tab_or_newline(this, "\n", e);
    }
  });

  $("form").on("keypress", function (e) {
    if (e.keyCode == 13) {
      return false;
    }
  });

  enableAutocomplete("#user_info_attributes_company");

  $("#industries_search").autocomplete({
    source: $("#industries_search").data("autocomplete-source"),
    open: function (event, ui) {
      $(".ui-autocomplete")
        .find(".ui-menu-item")
        .click(function () {
          if (
            !$("#industries").val().split("]ind=[").includes($(this).text())
          ) {
            addIndustryTag(
              $(this).text(),
              "#industries",
              "#tag_search_container",
              "#industries_search"
            );
          }
        });
    },
    select: function (event, ui) {
      event.preventDefault();
    },
  });

  $("#btn_add_industry_tags").on("click", function () {
    var searchVal = $("#industries_search").val().trim();
    if (
      searchVal.length > 0 &&
      !$("#industries").val().split("]ind=[").includes(searchVal)
    ) {
      addIndustryTag(
        searchVal,
        "#industries",
        "#tag_search_container",
        "#industries_search"
      );
    }
  });

  $("#industries_search").on("keypress", function (e) {
    var searchVal = $("#industries_search").val();
    if (
      e.keyCode == 13 &&
      searchVal?.length > 0 &&
      !$("#industries").val().split("]ind=[").includes(searchVal)
    ) {
      addIndustryTag(
        searchVal,
        "#industries",
        "#tag_search_container",
        "#industries_search"
      );
    }
  });

  $("#registrations_page_photo_button").click(function () {
    $("#user_profile_photo").click();
  });

  $("#user_profile_photo").on("change", function () {
    displayPhotoPlaceholder("#photo_attach_placeholder", this);
  });

  $("#registrations_cancel_link").click(function () {
    $("#dialog-cancel_mentor_application").dialog({
      width: "auto",
      modal: true,

      buttons: {
        "Cancel Application": function () {
          document.body.style.cursor = "wait";
          window.location = $("#cancel_mentor_application").attr("href");
        },

        Cancel: function () {
          $(this).dialog("close");
        },
      },
    });
  });

  var profile_photo = $("#user_profile_photo").val() || "";

  if (profile_photo.length > 0) {
    displayPhotoPlaceholder("#photo_attach_placeholder", "#user_profile_photo");
  }

  if ($("#industries").val()?.length > 0) {
    $($("#industries").val().split("]ind=[")).each(function (index, industry) {
      if (industry?.length > 0) {
        loadIndustryTags(industry, "#tag_search_container");
      }
    });
  }

  removeIndustryTag($("i.remove_tag"), "#industries");

  $(".previous_page_btn").click(function () {
    $(
      ".application_page_section, #registrations_cancel_link, #registrations_submit_link, .previous_page_btn, .next_page_btn"
    ).toggle();
  });

  $(".next_page_btn").click(function (e) {
    var fields = getFieldValues(".must_fill");

    if (fields.includes("")) {
      submitAlert(e, "You must fill up all fields");
    } else if (
      $("#user_profile_photo").val() === "" &&
      $("#photo_attach_placeholder").attr("data-value") === "false"
    ) {
      submitAlert(e, "A profile photo is required");
    } else if ($("#industries").val().length === 0) {
      submitAlert(e, "You must specify at least one skill");
    } else {
      $(
        ".application_page_section, #registrations_cancel_link, #registrations_submit_link, .previous_page_btn, .next_page_btn, .simple-hide"
      ).toggle();
    }
  });

  var interval_hash = $("data#time_interval").data("value");
  var program_id = $("data#time_interval").data("program-id");
  var update_path = $("data#time_interval").data("update-path");
  bindAddRemoveTimeslots("#add_selected_time, .time_value .removing_times");

  function bindAddRemoveTimeslots(targets) {
    $(targets).click(function () {
      var removing = $(this).hasClass("removing_times");

      if (removing) {
        var day = $(this).closest(".time_value").data("day");
        var start = $(this).closest(".time_value").data("start");
        var end = $(this).closest(".time_value").data("end");
      } else {
        var day = $("#selected_day").find("option:selected").val();
        var start = $("#start_time").val();
        var end = $("#end_time").val();
        var start_index = interval_hash.indexOf(start);
        var end_index = interval_hash.indexOf(end);
        var end_index = end_index === 0 ? 48 : end_index;
      }

      if (!removing && end_index <= start_index) {
        popupAlert("Start time must be earlier than end time");
      } else {
        showFlLoader();

        $.ajax({
          method: "POST",
          url: update_path,
          data: {
            removing: removing,
            day: day,
            start: start,
            end: end,
            program_id: program_id,
          },
          success: function (response) {
            if (response.error) {
              popupAlert(response.error);
            } else {
              $(
                '.timeslot_container[data-day="' +
                $(response).data("day") +
                '"]'
              ).html($(response).html());
              bindAddRemoveTimeslots(
                '.time_value[data-day="' +
                $(response).data("day") +
                '"] .removing_times'
              );
              $("#registrations_submit_link").removeClass("btn-outline-blue");
              $("#registrations_submit_link").addClass("btn-blue");
              $("#registrations_submit_link").val("Finish");
            }

            hideFlLoader();
          },
        });
      }
    });
  }

  $(".mentor_details-selectable_industry").click(function () {
    if ($(this).attr("data-active") === "true") {
      $(this).attr("data-active", "false");
      $('span.tag_item:contains("' + $(this).text() + '")')
        .find(".remove_tag")
        .click();
    } else {
      $(this).attr("data-active", "true");
      addIndustryTag(
        $(this).text(),
        "#industries",
        "#tag_search_container",
        "#industries_search"
      );
      bindSelectableRemoveButton($(this).text());
    }
  });

  function bindSelectableRemoveButton(text) {
    $('span.tag_item:contains("' + text + '") .remove_tag').click(function () {
      content = $(this).closest("span.tag_item").text();
      $('.mentor_details-selectable_industry:contains("' + content + '")').attr(
        "data-active",
        "false"
      );
    });
  }

  $("#timeslot_timezone").change(function () {
    $.ajax({
      method: "POST",
      url: "update_availability_timezone",
      data: {
        timezone: $(this).val(),
        program_id: $("data#time_interval").data("program-id"),
      },
      success: function (response) {
        popupNotification("Timezone updated to " + response.timezone);
      },
    });
  });
});
